import { string, object, array, boolean } from 'yup'

const VALID_REGEX = /^[\d\sA-Za-z]+$/

const editTopicSchema = object({
  name: string().required('Please enter a valid topic name'),
  primaryKeyword: string()
    .matches(VALID_REGEX, 'Please enter a valid keyword')
    .required('This is a required field'),
  secondaryKeywords: array()
    .of(string())
    .test(
      'isValidSecondaryKeyword',
      param => {
        const invalidKeyword = param.value.find(
          (keyword: string) => !VALID_REGEX.test(keyword)
        )
        return `Please enter a valid keyword: ${invalidKeyword}`
      },
      values => !values?.some(value => value && !VALID_REGEX.test(value))
    ),
  shouldAttachSeoGuidelines: boolean().required().default(false),
})

export default editTopicSchema
